export default "__VITE_PUBLIC_ASSET__7a7756c5__"